import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { RespiAllerGradingDataV1 } from './respiAllerGradingDataV1';

export type RespiAllerGradingReadLabelV1 =
    | 'Beoordeling medisch specialist'
    | 'Gegenereerde conclusie(s)'
    | 'Gehele advies in Ksyos'
    | 'ICD-10'
    | 'Individuele aanbevelingen'
    | 'Medicamenteus advies'
    | 'Niet-medicamenteus advies'
    | 'Opmerkingen voor de huisarts';

export type RespiAllerGradingReadSectionTitleV1 = 'Notities' | 'Gegevens patiënt';

export type RespiAllerGradingReadDataV1 = RespiAllerGradingDataV1 & {
    patient_emailadres: string;
    patient_telefoonnummer_mobiel: string;
};

export type RespiAllerGradingReadKeyV1 = keyof RespiAllerGradingReadDataV1;

export const respiAllerGradingReadSectionsV1: TypedReadSchema<
    RespiAllerGradingReadKeyV1,
    RespiAllerGradingReadLabelV1,
    RespiAllerGradingReadSectionTitleV1
>[] = [
    {
        items: [
            { key: 'conclusie', label: 'Gegenereerde conclusie(s)' },
            { key: 'individuele_aanbevelingen', label: 'Individuele aanbevelingen' },
            { key: 'medicamenteus_advies', label: 'Medicamenteus advies' },
            { key: 'niet_medicamenteus_advies', label: 'Niet-medicamenteus advies' },
        ],
        sectionTitle: 'Notities',
    },
];
